<template>
<div>
<loading :active.sync="isLoading"></loading>
<Header />
<div id="kv" class="privacy">
  <p>プライバシーポリシー</p>
</div>
<main>
    <div class="privacy_content">
      <p>マジェスティゴルフ株式会社（以下、「当社」といいます。）は、個人情報の重要性を認識し、以下のプライバシーポリシー(以下、「本プライバシーポリシー」といいます。)に従い、個人情報の適切な取扱い及び保護に努めます。</p>
      <p>1.	法令等の遵守について<br>
        当社は、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）その他の関係法令及び「個人情報の保護に関する法律についてのガイドライン（通則編）」その他国が定める指針のうち遵守が必須とされている事項を遵守して、個人情報の適切な取扱いを行います。</p>
      <p>2.	個人情報の取得<br>
        当社は、適正にお客様、取引先、株主の皆様、当社役員・従業員等の個人情報（氏名、住所、生年月日、性別、年齢、メールアドレスその他個人情報保護法第2条第1項により定義される個人情報）を取得し、偽りその他不正の手段により取得することはいたしません。</p>
      <p>3.	個人情報の利用目的<br>
        当社は、当社が取得する個人情報を、次の利用目的の範囲内において使用いたします。当社は、次の利用目的を、関連性を有すると合理的に認められる範囲で変更することがあり、変更した場合には、変更された利用目的について、ご本人に通知又は公表します。<br>
        (1)	当社サービスを提供するため<br>
        (2)	お客様又は取引先に商品、景品を配送/郵送するため<br>
        (3)	当社サービスについての情報提供等のため<br>
        (4)	当社のキャンペーン、イベント、ゴルフコンペ、ゴルフツアー等のご案内のため<br>
        (5)	当社サービスに関するマーケティング調査及び分析を実施するため<br>
        (6)	カスタマーサポートサービス及び紛争解決のため<br>
        (7)	当社サービスの不正利用及び悪用を検知し、対応するため<br>
        (8)	当社へのお問い合わせに対応するため<br>
        (9)	株主情報の管理及び法令に基づく権利の行使・義務の履行のため<br>
        (10)	従業者の採用選考及び採用後の人事管理のため<br>
        (11)	その他、上記利用目的に付随又は関連する目的のため</p>
      <p>4.	安全管理措置の実施について<br>
        当社は、個人データについて、不正アクセス、漏えい、滅失又は毀損等の防止に努め、個人データの管理のために必要な組織的、人的、物理的及び技術的安全管理措置を講じます。</p>
      <p>5.	従業者の監督について<br>
        当社は、従業者が個人データの重要性を理解し、個人データを適切に取り扱うよう教育し、従業者に個人データを取り扱わせる場合には、個人データの安全管理が図られるよう、必要かつ適切な監督を行います。</p>
      <p>6.	委託先の監督について<br>
        当社が個人データの取扱いを委託する場合は、個人データの安全管理が図られるよう必要かつ適切な監督を行います。</p>
      <p>7.	個人データの第三者提供について<br>
        当社は、法令で例外として定められている場合を除き、個人データをあらかじめご本人の同意を得ることなく第三者に提供することはいたしません。</p>
      <p>8.	個人データの確認・記録義務について<br>
        当社は、法令で不要とされている場合を除き、第三者に個人データを提供したとき、又は受けたときは、法令で定められた確認・記録義務を適正に履行いたします。</p>
      <p>9.	匿名加工情報の取扱いについて<br>
        当社は、匿名加工情報を作成する場合は、法令で定められた基準を遵守し、適切な安全管理措置を実施します。</p>
      <p>10.	個人情報の漏えい等の事故発生時の対応について<br>
        当社は、個人情報の漏えい等の事故が発生した場合は、被害を最小限にとどめるために迅速に対応し、再発防止に向けた取り組みを行います。</p>
      <p>11.	個人情報保護管理体制について<br>
        当社は、個人情報報保護のための管理体制および取り組みを継続的に見直し、定期的に評価を実施し、その改善に努めてまいります。</p>
      <p>13.	保有個人データに関する開示・訂正等・利用停止等に関するお問い合わせ方法<br>
        当社は、ご本人から、個人情報に係る保有個人データに関する利用目的の通知、開示、訂正・追加又は削除（以下「訂正等」といいます。）、利用停止・削除のお申し出があった場合の手続きの概要は、以下のとおりです。詳細は手続案内書をご確認ください。<br>
        (1)次の項目を必ずご記載の上、「利用目的の通知」、保有個人データの「開示」、「訂正等」を希望する旨をお申し出ください。<br>
        　　　　・氏名（ふりがな）<br>
        　　　　・メールアドレス<br>
        　　　　・件名：「個人情報に関するお問い合わせ」<br>
        (2)上記お申し出を受け付けた後、当社からご本人に対して、手続案内書及び申請書を送付いたします。<br>
        (3)申請書に必要事項をご記入の上、当社指定の本人確認書類（代理の場合には、本人確認書類に加えて代理権原確認書類）と共に郵送にて当社宛てにお送りください。<br>
        (4)当社にて、提出書類の内容及びご本人であることを確認させていただいた上で、対応いたします。なお、ご本人の申請に応じられない場合は、その理由を遅滞なくご連絡いたします。<br>
        (5)保有個人データの利用目的の通知及び開示に係わる手数料として、以下の手数料を請求させていただきます。<br>
        　　　　・申請１回あたりの手数料：1,000円（消費税及び地方消費税込み）<br>
        ※　上記手数料は、書留（本人限定郵便）の郵便料金相当額です。<br>
        　　（ご参考）25ｇまでの定形郵便物の場合の料金<br>
        郵便料金82円＋書留料金430円＋本人限定受取郵便料金100円＋事務作業費388円＝1,000円<br>
        ※　1回の申請につき、保有個人データ10件までとさせていただきます。<br>
        　　　　・支払方法：1,000円分の郵便切手を申請書類に同封し、第17項記載の宛先にご郵送ください。</p>
      <p>14.	お客様等のアクセスログについて<br>
        当社は 傾向の分析、サイトの管理､ユーザーの動向の探知､人口統計学的情報の収集等のためにIPアドレスを使用しますが、IPアドレスは、特定の個人を識別しうる情報を含むものではありません。</p>
      <p>15.	クッキー（Cookies）について<br>
        当社は、お客様が当社ホームページ（以下「当社サイト」といいます。）にアクセスされた場合、クッキー（Cookies）に含まれる当サイト上での視聴行動についての全体傾向やパターンなどの情報を収集する場合があります。収集した情報については、お客様の個人情報と同様に扱われます。<br>
        なお、お客様等がご自身に関する情報が収集されることを希望しない場合には、ブラウザの設定によりクッキーの受け取りを拒否することも可能です。お客様等のご希望でクッキーの受け入れを拒否された場合においても、当社サイトにて提供されるサービスの利用に不都合が生じることはございません。</p>
      <p>16.	個人情報の改定について<br>
        当社は、法令の改正及び／又は当社の運営上の必要性に従い、本プライバシーポリシーを適宜改定し、当社サイトにて告知します。改定後のプライバシーポリシーは、後記の改定日に効力を生じるものとし、お客様等は、当社サービスの利用を継続される場合には、改定後の本プライバシーポリシーの内容を十分に理解した上で内容に同意しているとみなされます。</p>
      <p>17.	個人情報の取扱いに関するご意見・お問い合わせ窓口<br>
        個人情報の取扱いに関するご意見・お問い合わせは、以下の窓口までご連絡ください。<br>
        【個人情報に関するお問い合わせ窓口】<br>
        (1)問い合わせ先：マジェスティゴルフ株式会社<br>
        (2)住所：〒100-0005 東京都千代田区丸の内2－1－1 明治生命館7階<br>
        (3)E-mail：golf-desk@majesty-golf.com</p>
      <p>制定日：2019年08月08日</p>
      <h2 class="black">ソーシャルメディアポリシー</h2>
      <p>1.	1）ソーシャルメディア活用目的</p>
      <p>マジェスティ ゴルフ株式会社は、当社が提供する製品やサービスをはじめとする事業活動をより多くの方に認知いただくこと、ソーシャルメディアを通じていただくご意見を製品やサービスをはじめとする事業活動に活用することを目的とし、ソーシャルメディアを利用いたします。<br>
        利用にあたり、以下のソーシャルメディアポリシーを定め、これを遵守します。以下、ソーシャルメディアを「SNS」と記載します。</p>
      <p>2.	2）行動原則</p>
      <p>１　当社は、SNSが、不特定多数が利用・閲覧でき、全世界に対して発信され、一度投稿されたものを完全に削除することは困難であるという特性を有することを理解し、これを念頭に置いた上で、責任をもって情報発信を行います。<br>
        ２　当社は、投稿にあたり、法令・社内ルールを遵守します。<br>
        ３　当社は、投稿にあたり、第三者の著作権・名誉権等の権利侵害行為をしないことを遵守します。<br>
        ４　当社は、社外秘情報、お客様およびお取引様の非公開情報を、相手方の同意なく開示することは致しません。その他、個人情報、プライバシーへの配慮を常に意識し、これを侵害するような発信を行いません。</p>
      <p>3.	3）免責事項</p>
      <p>１　当社のSNSアカウントへユーザー様から投稿されたコンテンツ及び投稿内容一切について、当社はその真偽等に関する責任を負いません。<br>
        ２　ユーザー様からいただいた投稿に対して、個別にご返信することはいたしかねますので、あらかじめご了承ください。<br>
        ３　当社は、当社のSNSアカウントを介し、ユーザー様間、もしくはユーザー様と第三者間のトラブルが生じた場合でも、それによって生じた損害に対する一切の責任を負いません。<br>
        ４　ユーザー様が当社のSNSアカウントに投稿するテキスト、ソフトウェア、音楽、音声、写真、グラフィックス、ビデオ、ページレイアウト、デザインやその他一切のコンテンツは、それぞれの著作権、商標権、又はその他の所有権及び法律によって保護されていることを前提に、これを侵害していないことを確認した上で投稿されたものとみなします。<br>
        ５　当社は、事業戦略上の理由により、当社のSNSアカウントに対するユーザー様のフォローまたは投稿等をブロックする場合があります。この場合も、ユーザー様への事前確認等は行いませんので、ご了承ください。<br>
        ６　当社のSNSアカウントを利用されたこと、もしくは何らかの理由で利用することができなかったことによって生じるお客様のいかなる損害についても、運営主である当社は何ら責任を負うものではありません。<br>
        ７　また、各ソーシャルメディアのシステム運用状況や技術的なご質問、ソフトウェアの機能やご利用方法に関する質問など、これらについてはお答えすることができません。<br>
        ８　公式アカウントの運営は予告なく終了、削除される場合があります。</p>
      <p>4.	4）削除事由</p>
      <p>当社は、下記の各事由に該当するユーザーコンテンツの投稿を受け付けません。下記の各事由に該当する投稿に関しては、当社の独断によって削除・修正を行います。この場合、投稿削除の要否に関する判断は、当社が独自に行い、ユーザー様への事前確認等は行いませんので、ご了承ください。</p>
      <p>１　各公式アカウントに関係しない情報、または投稿<br>
        ２　誹謗中傷や第三者の権利を侵害する情報、または投稿<br>
        ３　違法な情報や猥褻な内容を含む情報、または投稿<br>
        ４　無許可で権利が保護されているソフトウェアのアップロード<br>
        ５　コンピューターウイルスを含むファイルのアップロード<br>
        ６　署名や法律上の表示が削除された情報、または投稿<br>
        ７　作成者名が偽装された情報、または投稿<br>
        ８　その他当社が不適切と判断した情報、または投稿</p>
    </div>
</main>
<Footer />
</div>
</template>

<script>
import Footer from './footer'
import Header from './header'
import Loading from 'vue-loading-overlay'

export default {
  data: function () {
    return {
      isLoading: false
    }
  },
  components: {
    Footer,
    Header,
    Loading
  }
}
</script>
